import { shallowEqual, useSelector } from "react-redux";
import NotesComponent from "../notes/NotesComponent";
import TabHeader from "../../tab/TabHeader";
import NegotiationDetails from "./NegotiationDetails";
import Tag from "../../../fragments/Tag";
import { getNegStatusOption, resolveNegStatus } from "../../../../lib/negotiationNegStatus";

function selectNegotiationNegStatus(state) {
    const caseNegotiation = state.case.activeCase?.case_negotiation;
    const practices = state.case.activeCase?.practices;

    return {
        negStatus: resolveNegStatus(caseNegotiation, practices),
        statusKey: [
            caseNegotiation?.escalate_negotiation,
            caseNegotiation?.total_accepted_at,
            (practices ?? [])
                .map((p) => `${p?.id}:${p?.lia_neg_amount}:${p?.um_neg_amount}`)
                .join("|"),
        ].join("||"),
    };
}

export default function NegotiationTab({ inWorkQ }) {
    const { negStatus } = useSelector(selectNegotiationNegStatus, shallowEqual);
    const negStatusOption = getNegStatusOption(negStatus);

    return <>
        <TabHeader>
            <div className="flex-container">
                <h2>Negotiation</h2>
                <NotesComponent noteTypeId={16} inWorkQ={inWorkQ} />
            </div>
            {negStatusOption ? (
                <Tag color={negStatusOption.color}>{negStatusOption.label}</Tag>
            ) : null}
        </TabHeader>
        <div>
            <NegotiationDetails />
        </div>
    </>
}
